import { injectable } from "inversify";
import * as PIXI from "pixi.js-legacy";
import { pixiSetTimeoutAsync } from "../../framework/src/engine/pixi/pixiTimeout";
import { getSprite } from "../../framework/src/modules/Sprite";
import { EASE, getTween, getTweenAsync } from "../../framework/src/modules/Tween";

@injectable()
export default class Win {

    backgroundImg: PIXI.Sprite;
    score: PIXI.BitmapText;

    constructor(){        
        
        this.backgroundImg = getSprite("win_background", 640, 360, { x: 0, y: 0 });
        this.backgroundImg.alpha = 0;
        this.backgroundImg.name = "Win Background";
        this.backgroundImg.pivot.set(this.backgroundImg.width / 2, this.backgroundImg.height / 2);        
        this.reset(this.backgroundImg);

        let style: PIXI.IBitmapTextStyle = {
            fontName: "font_win-export",
            fontSize: 80,
            align: "right",
            tint: 0xFFFFFF,
            letterSpacing: 0,
            maxWidth: 1280
        };

        this.score = new PIXI.BitmapText("", style);        
        this.score.alpha = 0;
        this.score.name = "Win Score Text";        
        this.score.position.set(640, 347);
        this.score.anchor.set(.5,0);

        this.reset(this.score);
    }

    async reset(dispObj: PIXI.Container) {
        await getTweenAsync(dispObj, { alpha: 0 }, 100, EASE.LINEAR)
        
        dispObj.alpha = 0;
        dispObj.scale.set(1, 1);
        dispObj.visible = false;        
    }
    
    async play(winScore: number, dontFastForward: boolean) {

        this.score.text = this.insertSpaces(winScore.toString());

        this.score.anchor.set(.5,0);
        this.score.scale.set(1.1, 1.1);
        this.score.visible = true;

        this.backgroundImg.visible = true;

        let delay = 0.1;
        if (dontFastForward) {
            delay = 1.5;            
            this.score.scale.set(1.4, 1.4);//2,2);//8, 8);   
        }
        await pixiSetTimeoutAsync(delay)
        await this.winAnimation(dontFastForward);
    }

    insertSpaces(str: string): string {
        let spaceIndex = 3;
        while (spaceIndex < str.length) {
            str = str.slice(-str.length, -spaceIndex) + " " + str.slice(-spaceIndex);
            spaceIndex += 4;
        }
        return str;
    }

    async winAnimation(dontFastForwardSkip: boolean) {
        // values for the short / skip animation
        let time1 = 150;
        let time2 = 250;
        let time3 = 0.15; 

        if (dontFastForwardSkip) { // values for the normal NON skip animation
            time1 *=2;
            time2 *=2;
            time3 *=2;            
        }
        
        if (dontFastForwardSkip || this.backgroundImg.alpha != 0.8) {
            getTweenAsync(this.backgroundImg, { alpha: 0.8/*1*/ }, time1, EASE.LINEAR);
        }

        getTweenAsync(this.score, { alpha: 1 }, time1, EASE.LINEAR);
        await getTweenAsync(this.score.scale, { x: 1, y: 1 }, time2, EASE.BACK_O);
        
        await pixiSetTimeoutAsync(time3);

        await this.reset(this.score);
        this.score.text = "";

        if (dontFastForwardSkip) {
            await this.reset(this.backgroundImg);
        }
    }

    destroy() {
        for (let i = this.score.children.length - 1; i >= 0; i--) {
            let child = this.score.children[i];
            child.destroy();
        }
        
        this.backgroundImg.alpha = 0 ;
        this.backgroundImg.visible = false ;
        this.backgroundImg.destroy({children:true, baseTexture:true});
        this.backgroundImg = undefined;

        this.score.alpha = 0;
        this.score.visible = false;
        this.score.destroy({children:true , baseTexture:true});
        this.score = undefined;
    }
}